import { getUserRank, getUserRankRule } from '@/api/login'

export const levelMixins = {
  data() {
    return {
      isMax: false, // 是否已经升级到最高等级
      data: {
        name: null, // 标题
        num: null, // 已完成数量
        all: null, // 需要完成数量
        per: 0, // 完成百分比
        label_start: null,
        label_end: null,
        unit: null,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      Promise.all([getUserRankRule(), getUserRank()]).then(([res1, res2]) => {
        const userRankRule = res1.data
        const userRank = res2.data
        this.$store.dispatch('user/setUserInfoRank', userRank.rankName) // 设置全局等级名称
        this.handleData(userRankRule, userRank)
      })
    },
    handleData(userRankRule, userRank) {
      const maxRankId = userRankRule[userRankRule.length - 1].rankLevel
      this.data.name = userRank.rankName + '升级冲刺'
      if (userRank.rankLevel < maxRankId) {
        const i = userRankRule.find(
          (item) => item.rankLevel === userRank.rankLevel + 1
        )
        this.calcData(i, userRank)
      } else {
        this.isMax = true
      }
    },
    calcData(rule, rank) {
      if (rule.upOrderNum && rule.upOrderNum > rank.upOrderNum) {
        this.data.num = rank.upOrderNum
        this.data.all = rule.upOrderNum
        this.data.per = ((this.data.num / this.data.all) * 100).toFixed(2)
        this.data.label_start = '完成'
        this.data.label_end = '笔自购或销售订单'
        this.data.unit = '笔'
        return
      }
      if (rule.upJuniorNum && rule.upJuniorNum > rank.upJuniorNum) {
        this.data.num = rank.upJuniorNum
        this.data.all = rule.upJuniorNum
        this.data.per = ((this.data.num / this.data.all) * 100).toFixed(2)
        this.data.label_start = '下级店长达到'
        this.data.label_end = '人'
        this.data.unit = '人'
        return
      }
      if (rule.upAmount && rule.upAmount > rank.upAmount) {
        this.data.num = rank.upAmount
        this.data.all = rule.upAmount
        this.data.per = ((this.data.num / this.data.all) * 100).toFixed(2)
        this.data.label_start = '自营店铺省赚金达到'
        this.data.label_end = '元'
        this.data.unit = '元'
        return
      }
    },
  },
}